import { Link } from "react-router-dom";
import { BreadcrumbNav as RothzergBreadcrumb } from "rothzerg-ui";
import type { BreadcrumbItem } from "@/types/catalog";

type BreadcrumbNavProps = {
  items: BreadcrumbItem[];
};

export function BreadcrumbNav({ items }: BreadcrumbNavProps) {
  return (
    <div id="breadcrumb-nav">
    <RothzergBreadcrumb
      items={items}
      renderLink={(item, className) =>
        item.href ? (
          <Link to={item.href} className={className}>
            {item.label}
          </Link>
        ) : (
          <span className={className}>{item.label}</span>
        )
      }
    />
    </div>
  );
}
